import {take, fork, cancel} from 'redux-saga/effects';
import {LOCATION_CHANGE, matchPath, parseSearchQueryParams} from '@computerrock/formation-router';
import routePaths from '../../routePaths';
import savScreenTabs from '../savScreenTabs';
import * as savActionTypes from '../savActionTypes';
import onSAVMapClickSelectContractPartner from './onSAVMapClickSelectContractPartner';

const savMapContractPartnerWatcher = function* savMapContractPartnerWatcher() {
    mainFlow: while (true) {
        const {payload} = yield take(savActionTypes.START_SAV_MAP_CONTRACT_PARTNER_WATCHER);

        const onSAVMapClickSelectContractPartnerTask = yield fork(onSAVMapClickSelectContractPartner, payload);

        while (true) {
            const watcherTerminationAction = yield take([
                savActionTypes.STOP_SAV_MAP_CONTRACT_PARTNER_WATCHER,
                LOCATION_CHANGE,
            ]);

            if (watcherTerminationAction.type === savActionTypes.STOP_SAV_MAP_CONTRACT_PARTNER_WATCHER) {
                yield cancel(onSAVMapClickSelectContractPartnerTask);
                continue mainFlow;
            }

            const {payload} = watcherTerminationAction;
            const {location} = payload;

            const savRouteMatch = matchPath(location.pathname, {
                path: routePaths.SERVICE_ASSIGNMENT_VEHICLE,
                exact: true,
            });
            const {activeTab} = savRouteMatch ? parseSearchQueryParams(location.search) : {};
            if (!savRouteMatch || activeTab !== savScreenTabs.CONTRACT_PARTNER) {
                yield cancel(onSAVMapClickSelectContractPartnerTask);
                continue mainFlow;
            }
        }
    }
};

export default savMapContractPartnerWatcher;
